module.exports = __webpack_public_path__ + "img/yiruntong.450f6bf4.svg";